<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container md="10">
      <v-row dense v-if="userProfile.memberAccount.type=='AAA' || userProfile.memberAccount.type=='BBB'">
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-text-field
            label="通譯人員姓名"
            v-model="queryObject.name"
            @input="getMemberFromServer"
            clearable
          />
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-select
            :items="getCodeDateUtil('score')"
            label="評價星等"
            clearable
            v-model="score"
            @change="getMemberFromServer"
          />
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" xs="12" sm="12" md="12" >
        
              <span class="red--text">共 {{totalCount}} 筆，每頁筆數</span>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn dark text color="red" class="ml-2" v-on="on">
                    {{ pageSize }}
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(number, index) in itemsPerPageArray"
                    :key="index"
                    @click="updateItemsPerPage(number)"
                  >
                    <v-list-item-title>{{ number }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" xs="12" sm="12" md="12" >
          <v-data-iterator
            :items="items"
            :items-per-page.sync="pageSize"
            :page="currentPage"
            hide-default-footer
            no-data-text="查無資料"
          >
            <template v-slot:default="props">
              <v-row>
                <!-- <v-col v-for="(item,i) in props.items" :key="i" cols="12" sm="5" md="5" lg="6"> -->
                <v-expansion-panels v-for="(item,i) in props.items" :key="i" :focusable="true">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <v-row justify="space-between">
                      <v-col >
                        <h5>{{ item.name }} ({{item.gender=='M'?'男':'女'}})</h5>
                        <span v-if="userProfile.memberAccount.type=='AAA'">
                          <v-chip color="indigo" text-color="white" @click="showCaseList(item)">
                            <!-- <v-avatar left>
                              <v-icon>mdi-account-card-details-outline</v-icon>
                            </v-avatar>-->
                            案件列表
                          </v-chip>
                        </span>
                      </v-col>
                      <v-col >
                        <h5>案件數：{{ item.caseCount }}</h5>
                      </v-col>
                      <v-col >
                        <v-rating
                          readonly
                          v-model="item.score"
                          color="yellow darken-3"
                          background-color="grey darken-1"
                          empty-icon="$ratingFull"
                          half-increments
                          hover
                          dense
                        ></v-rating>
                      </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list dense>
                        <v-list-item>
                          <v-tooltip left>
                            <template v-slot:activator="{ on }">
                              <v-list-item-content
                                class="align-end"
                                v-on="on"
                              >{{ item.nationality }}</v-list-item-content>
                            </template>
                            <span>國籍</span>
                          </v-tooltip>
                        </v-list-item>
                        <v-list-item>
                          <v-tooltip left>
                            <template v-slot:activator="{ on }">
                              <v-list-item-content
                                class="align-end"
                                v-on="on"
                              >{{ item.qualificationInTaiwan }}</v-list-item-content>
                            </template>
                            <span>在臺資格與取得證件</span>
                          </v-tooltip>
                        </v-list-item>
                        <v-list-item>
                          <v-tooltip left>
                            <template v-slot:activator="{ on }">
                              <v-list-item-content
                                class="align-end"
                                v-on="on"
                              >{{ convertDBDateToString(item.serviceStartDate) }}</v-list-item-content>
                            </template>
                            <span>開始從事通譯服務時間</span>
                          </v-tooltip>
                        </v-list-item>
                        <v-list-item>
                          <v-tooltip left>
                            <template v-slot:activator="{ on }">
                              <v-list-item-content
                                class="align-end"
                                v-on="on"
                              >{{ item.educationLevel }}</v-list-item-content>
                            </template>
                            <span>教育程度</span>
                          </v-tooltip>
                        </v-list-item>
                        <v-list-item>
                          <v-tooltip left>
                            <template v-slot:activator="{ on }">
                              <v-list-item-content
                                class="align-end"
                                v-on="on"
                              >{{ item.serviceType }}</v-list-item-content>
                            </template>
                            <span>服務類型</span>
                          </v-tooltip>
                        </v-list-item>
                        <v-list-item>
                          <v-tooltip left>
                            <template v-slot:activator="{ on }">
                              <v-list-item-content
                                class="align-end"
                                v-on="on"
                              >{{ item.serviceLanguage }}</v-list-item-content>
                            </template>
                            <span>熟悉語言</span>
                          </v-tooltip>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-dialog v-model="caseDialog" max-width="1024">
                  <v-card outlined>
                    <v-card-title class="red" dark>
                      <h2>
                        <font style="color:white">案件列表</font>
                      </h2>
                    </v-card-title>
                    <v-col cols="12" sm="5" md="5">
                      <v-dialog
                        ref="dialog2"
                        v-model="selectDate"
                        :return-value.sync="dates"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="dateRangeText"
                            @click:clear="dates=[];"
                            label="案件需求時間起訖日"
                            readonly
                            v-on="on"
                            clearable
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dates"
                          locale="zh-tw"
                          style="font-family:Microsoft JhengHei;"
                          color="red"
                          scrollable
                          range
                        >
                          <v-spacer></v-spacer>
                          
              <v-btn color="grey lighten-3" style="color:black;" @click="selectDate = false">取消</v-btn>
              <v-btn color="red" style="color:white;"  class="ma-2" @click="$refs.dialog2.save(dates);getCaseList();" >確定</v-btn>

                        </v-date-picker>
                      </v-dialog>
                    </v-col>

                    <v-toolbar-title>
                      <v-row class="pa-3 ma-5" align="center" justify="center">
                        <span class="red--text">共 {{caseTotalCount}} 筆，每頁筆數</span>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn dark text color="red" class="ml-2" v-on="on">
                              {{ casePageSize }}
                              <v-icon>mdi-chevron-down</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(number, index) in itemsPerPageArray"
                              :key="index"
                              @click="updateCaseDetailPerPage(number)"
                            >
                              <v-list-item-title>{{ number }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-row>
                    </v-toolbar-title>

                    <v-data-iterator
                      :items="caseItems"
                      :items-per-page.sync="casePageSize"
                      :page="caseCurrentPage"
                      hide-default-footer
                      no-data-text="查無資料"
                    >
                      <template v-slot:default="props">
                        <v-row>
                          <v-card-title>
                            <h4>{{ targetMember.name }}
                            ({{targetMember.gender=='M'?'男':'女'}}) 案件數：{{ targetMember.caseCount }}</h4>
                            <v-spacer />
                            <v-rating
                              readonly
                              v-model="targetMember.score"
                              color="yellow darken-3"
                              background-color="grey darken-1"
                              empty-icon="$ratingFull"
                              half-increments
                              hover
                            ></v-rating>
                          </v-card-title>
                          <v-col v-for="(item,i) in props.items" :key="i" cols="12">
                            <v-card>
                              <v-simple-table>
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th width="25%" ><font color="black"><h6>{{item.ic.deptName}}</h6></font></th>
                                      <th width="25%" ><font color="black"><h6>案件類型</h6></font></th>
                                      <th width="50%" ><font color="black"><h6>評價</h6></font></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <td v-if="userProfile.sysAdmin"><h6>{{ getDateFormat(item.ic.serviceDate,"yyyy-MM-dd",true)  }}</h6></td>
                                    <td v-else><h6>{{ getDateFormat(item.ic.serviceDate,"yyyy-MM",true)  }}</h6></td>
                                    <td><h6>{{ item.ic.caseType }}</h6></td>
                                    <td><h6>{{ item.detail.comment }}</h6></td>
                                  </tbody>
                                </template>
                              </v-simple-table>
                              <v-card-title>
                                <h6>整體評價</h6>
                                <v-rating
                                  readonly
                                  v-model="item.detail.scoreAll"
                                  color="yellow darken-3"
                                  background-color="grey darken-1"
                                  empty-icon="$ratingFull"
                                  half-increments
                                  hover
                                ></v-rating>
                                <h6>專業素養</h6>
                                <v-rating
                                  readonly
                                  v-model="item.detail.scoreProfession"
                                  color="yellow darken-3"
                                  background-color="grey darken-1"
                                  empty-icon="$ratingFull"
                                  half-increments
                                  hover
                                ></v-rating>
                                <h6>服務態度</h6>
                                <v-rating
                                  readonly
                                  v-model="item.detail.scoreAttitude"
                                  color="yellow darken-3"
                                  background-color="grey darken-1"
                                  empty-icon="$ratingFull"
                                  half-increments
                                  hover
                                ></v-rating>
                                <v-btn v-if="userProfile.sysAdmin"
                                  @click="dialogResponeDept= !dialogResponeDept;setTargetItem(item.ic,item.detail);"
                                >案件詳細內容</v-btn>
                              </v-card-title>
                              <v-divider></v-divider>
                            </v-card>
                          </v-col>
                        </v-row>
                      </template>
                    </v-data-iterator>
                    <div class="text-center pa-2 ma-2">
                      <v-pagination
                        color="red"
                        v-model="caseCurrentPage"
                        :length="caseMaxPage"
                        :total-visible="9"
                        @input="getCaseList()"
                      ></v-pagination>
                    </div>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>
            <template v-slot:footer>
                <div class="text-center pa-2 ma-2">
                  <v-pagination
                    color="red"
                    v-model="currentPage"
                    :length="maxPage"
                    :total-visible="9"
                    @input="getMemberFromServer()"
                  ></v-pagination>
                </div>
            </template>
          </v-data-iterator>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialogResponeDept" width="1000px">
      <v-card style="font-family:Microsoft JhengHei;">
        <v-card-title class="red" dark>
          <h2>
            <font style="color:white">詳細資訊</font>
          </h2>
        </v-card-title>
        <v-container>
          <v-row dense>
            <v-col cols="12" md="12">
                <h4>{{targetItem.deptName}}</h4>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
                    案件編號：{{targetItem.caseNo}}<br/>
                    語言別：{{targetItem.language}}<br/>
                    需求時間：{{convertDBDateToString(targetItem.serviceDate)}}<br/>
                    開始時間：{{targetItem.estimatedServiceStartTime}}<br/>
                    預計時數：{{targetItem.estimatedHours}}小時<br/>
                    服務地點：{{targetItem.serviceDistrict}}{{targetItem.serviceAddress}}<br/>
            </v-col>
            <v-col cols="12" md="6">
                    案件類型：{{targetItem.caseType}}<br/>
                    案件敘述：{{targetItem.caseNote}}<br/>
                    計費方式：{{targetItem.feeType}}<br/>
                    回覆期限：{{getDateFormat(targetItem.responseDueDate,"yyyy-MM-dd HH:mm",true)}}<br/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="12">
                    聯絡人：{{targetItem.contactName}}<br/>
                    聯絡電話：{{targetItem.contactHomeTel}}<br/>
                    行動電話：{{targetItem.contactMobileTel}}<br/>
            </v-col>
          </v-row>
          <v-row dense style="height: 20px;">
            <v-col cols="12" md="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row dense style="height: 20px;">
            <v-col cols="12" md="12">
            </v-col>
          </v-row>
          <v-row dense v-if="targetItem.status=='C04' && (targetItem.detailStatus=='I09' || targetItem.detailStatus=='I10')">
            <v-col cols="12" md="12" >
                <h4>服務紀錄</h4>
            </v-col>
          </v-row>
          <v-row dense v-if="targetItem.status=='C04' && (targetItem.detailStatus=='I09' || targetItem.detailStatus=='I10')">
            <v-col cols="12" md="12" >
                通譯報到時間：{{getDateFormat(targetItem.checkInDatetime,"yyyy-MM-dd HH:mm:ss",true)}}<br />
                服務開始時間：{{getDateFormat(targetItem.startServiceDatetime,"yyyy-MM-dd HH:mm:ss",true)}}<br />
                服務結束時間：{{getDateFormat(targetItem.finishServiceDatetime,"yyyy-MM-dd HH:mm:ss",true)}}<br />
                服務時數：{{ getTimeInterval(targetItem.finishServiceDatetime-targetItem.startServiceDatetime) }}<br />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters({
      getUserId: ["getUserId"],
      getTargetId: ["getTargetId"],
      getIcArray: ["getIcArray"],
      getSearchCase: ["getSearchCase"],
      getQueryObject: ["getQueryObject"],
      idbServerUrl: ["getIdbServerUrl"]
    }),
    filteredKeys() {
      return this.keys.filter(key => key !== "Name");
    },
    dateRangeText() {
      if (this.isNotBlankUtil(this.dates)) {
        return this.dates.join(" ~ ");
      } else {
        return "";
      }
    }
  },
  data() {
    return {
      // date: new Date().toISOString().substr(0, 10),
      dialogResponeDept: false,
      date: null,
      dates: [],
      selectDate: false,
      score: 0,
      menu: false,
      dialog: false,
      caseDialog: false,
      valid: false,
      firstname: "",
      lastname: "",
      nameRules: [
        v => !!v || "Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      rating: 3.5,
      targetMember: {},
      selectedArray: [],
      selectOption: ["A", "B"],
      itemsPerPageArray: [4, 8, 12],
      currentPage: 1,
      maxPage: 0,
      pageSize: 4,
      totalCount: 0,
      items: [],

      caseCurrentPage: 1,
      caseMaxPage: 0,
      casePageSize: 4,
      caseTotalCount: 0,
      caseItems: [],
      districtArray1: this.getCodeDateUtil("district"),
      districtArray2: [],
      city: String,
      searchCase: {},
      queryObject: {},
      dayArray: this.getCodeDateUtil("dayType"),
      heartArray: [],
      userProfile: JSON.parse(this.$localStorage.get("userProfileStr")),
      targetItem: {}
    };
  },
  methods: {
    ...mapActions([
      "updateUser",
      "updateTargetId",
      "updateIcArray",
      "updateSearchCase",
      "updateQueryObject"
    ]),
    setTargetItem(ic, detail) {
      let vm = this;
      vm.targetItem = ic;
      vm.targetItem.scoreAll = detail.scoreAll;
      vm.targetItem.scoreProfession = detail.scoreProfession;
      vm.targetItem.scoreAttitude = detail.scoreAttitude;
      vm.targetItem.commentIp = detail.comment;
      vm.targetItem.detailStatus = detail.status;
    },
    getDataByDistrict() {
      let vm = this;
      if (vm.isNotBlankUtil(vm.searchCase.searchDistrict))
        vm.queryObject.serviceCity = vm.searchCase.searchDistrict;
      vm.getMemberFromServer();
      vm.queryObject.serviceCity = vm.queryObject.serviceCity.split("-")[0];
    },
    showCaseList(item) {
      let vm = this;
      vm.caseItems = [];
      vm.dates = [];
      vm.caseDialog = true;
      vm.targetMember = item;
      vm.getCaseList();
    },
    getCaseList() {
      let vm = this;
      var queryObjectStr = JSON.stringify({
        // memberId: vm.userProfile.memberAccount.uuid
        memberId: vm.targetMember.uuid
      });
      var queryPagerStr = JSON.stringify({
        pageSize: vm.casePageSize,
        currentPage: vm.caseCurrentPage,
        sortColumnNameList: ["-createDate"]
      });

      var dateCriterion = [];
      if (vm.dates.length != 0) {
        dateCriterion.push({
          propertyName: "serviceDate",
          startDate: vm.dates[0],
          endDate: vm.dates[1]
        });
      }
      var criterionStr = JSON.stringify({
        in: [
          { propertyName: "status", value: "I09" },
          { propertyName: "status", value: "I10" }
        ],
        //只找需求單位評論過的案件
        isNotNull: [{ propertyName: "comment" }],
        subCriterion: dateCriterion
      });

      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/interpreterCaseDetail?queryString=" +
            encodeURIComponent(queryObjectStr) +
            "&queryPager=" +
            encodeURIComponent(queryPagerStr) +
            "&criterion=" +
            encodeURIComponent(criterionStr),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          //var dataResponse = JSON.stringify(response.data.resultList);
          //console.log(dataResponse);
          

          vm.caseItems = response.data.resultList;
          vm.caseCurrentPage = response.data.currentPage;
          vm.caseMaxPage = response.data.maxPage;
          vm.casePageSize = response.data.pageSize;
          vm.caseTotalCount = response.data.totalCount;

          // !vm.userProfile.sysAdmin

          if (!vm.userProfile.sysAdmin && vm.userProfile.memberAccount.type === "AAA") {
            //console.log("AAA \n"+ JSON.stringify(response.data.resultList));
            for (var i = 0; i < vm.caseItems.length; i++) {
              var nameDept = vm.caseItems[i].ic.deptName,
                nameLen = nameDept.length,
                showLen = Math.floor(nameLen/2),
                maskStr = "*",
                newName = "";
                newName = nameDept.substring(0,showLen) + maskStr.repeat(nameLen-showLen+2);
                vm.caseItems[i].ic.deptName = newName;
                console.log("aaa" + i + "  ---  " + newName);

            }
          }
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log(error);
        });
    },
    submitObject() {
      var vm = this;
      vm.updateIcArray(vm.selectedArray);
      vm.updateQueryObject(vm.queryObject);
      vm.updateSearchCase(vm.searchCase);
      vm.$router.push({
        path: "/contactInterpreter"
      });
    },
    isItemExist(item) {
      let vm = this;
      return vm.selectedArray.some(function(element) {
        return item.uuid == element.uuid;
      });
    },
    isHeartExist(item) {
      let vm = this;
      return vm.heartArray.some(function(element) {
        return item.uuid == element.pocketMemberId;
      });
    },
    addHeart(item) {
      let vm = this;
      var data = {
        memberId: vm.userProfile.memberAccount.uuid,
        pocketMemberId: item.uuid
      };
      vm.axios
        .post(vm.idbServerUrl + "idb/member/pocketMember", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: vm.$localStorage.get("idb_login_token")
          }
        })
        .then(function(response) {
          vm.heartArray.push(response.data);
          console.log("response " + JSON.stringify(response));
          console.log("SUCCESS!!!!!!! ");
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log("!!!! " + error);
        });
    },
    deleteHeart(item) {
      let vm = this;
      var pocket = vm.heartArray.find(function(element) {
        return item.uuid == element.pocketMemberId;
      });
      vm.axios
        .delete(
          vm.idbServerUrl + "idb/member/pocketMember/" + pocket.pocketId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          console.log("response " + JSON.stringify(response));
          console.log("SUCCESS!!!!!!! ");
          vm.heartArray.splice(vm.findHeartIndex(item), 1);
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log("!!!! " + error);
        });
    },
    findItemIndex(item) {
      let vm = this;
      let itemIndex = 0;
      vm.selectedArray.find(function(element, index) {
        if (item.uuid == element.uuid) itemIndex = index;
      });
      return itemIndex;
    },
    findHeartIndex(item) {
      let vm = this;
      let itemIndex = 0;
      vm.heartArray.find(function(element, index) {
        if (item.uuid == element.pocketMemberId) itemIndex = index;
      });
      return itemIndex;
    },
    selectedArrayPushObject(item) {
      var vm = this;
      var selectedFlag = false;
      vm.selectedArray.forEach(function(element) {
        if (element.name == item.name) {
          selectedFlag = true;
        }
      });
      if (!selectedFlag) {
        vm.selectedArray.push(item);
      }
    },
    nextPage() {
      if (this.currentPage + 1 <= this.maxPage) this.currentPage += 1;
      this.getMemberFromServer();
    },
    formerPage() {
      if (this.currentPage - 1 >= 1) this.currentPage -= 1;
      this.getMemberFromServer();
    },
    updateItemsPerPage(number) {
      this.pageSize = number;
      this.getMemberFromServer();
    },
    updateCaseDetailPerPage(number) {
      this.casePageSize = number;
      this.getCaseList();
    },
    parentDialog() {
      this.dialog = !this.dialog;
    },
    getMemberFromServer() {
      var vm = this;

      vm.queryObject.type = "CCC";
      var queryObjectStr = JSON.stringify(vm.queryObject);
      var queryPagerStr = JSON.stringify({
        pageSize: vm.pageSize,
        currentPage: vm.currentPage
        // sortColumnNameList: ["catShowOrder"]
      });

      if (vm.score == null) vm.score = 0;
      var criterionStr = JSON.stringify({
        ge: [{ propertyName: "score", value: vm.score, propertyType: "double" }]
      });

      if ( vm.userProfile.memberAccount.type == "BBB" ) {
        criterionStr = JSON.stringify({
          ge: [{ propertyName: "score", value: vm.score, propertyType: "double" }],
          equal: [{propertyName: "type", value: "CCC"}, 
          {propertyName: "mainDeptId", value: vm.userProfile.memberAccount.mainDeptId}]
        }); 
      } else if ( vm.userProfile.memberAccount.type == "CCC" ) {
        criterionStr = JSON.stringify({
          ge: [{ propertyName: "score", value: vm.score, propertyType: "double" }],
          equal: [{propertyName: "type", value: "CCC"}, 
          {propertyName: "uuid", value: vm.userProfile.memberAccount.uuid}]
        }); 
      }

      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/member/memberAccount?queryString=" +
            encodeURIComponent(queryObjectStr) +
            "&queryPager=" +
            encodeURIComponent(queryPagerStr) +
            "&criterion=" +
            encodeURIComponent(criterionStr),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          vm.items = response.data.resultList;
          vm.currentPage = response.data.currentPage;
          vm.maxPage = response.data.maxPage;
          vm.pageSize = response.data.pageSize;
          vm.totalCount = response.data.totalCount;
          // var dataResponse = JSON.stringify(response.data.resultList);
          console.log(JSON.stringify(response.data.resultList));
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log(error);
        });
    }
  },
  created() {
    // var vm = this;
    // vm.updateUser("updateUserDDDD");
    // vm.updateTargetId("updateTargetId");
  },
  mounted() {
    var vm = this;
    vm.getMemberFromServer();
  }
};
</script>




